export enum DocumentActionType {
    DOWNLOAD = "download",
    REDIRECT = "redirect"
}
